import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCNJK6BAura91KDTldK2CNHS5BChYa2g0I",
  authDomain: "resterenfrance-24f84.firebaseapp.com",
  projectId: "resterenfrance-24f84",
  storageBucket: "resterenfrance-24f84.firebasestorage.app",
  messagingSenderId: "591465146437",
  appId: "1:591465146437:web:328ea3c596c5f0d0d7db2c",
  measurementId: "G-9WTH697QQ8"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore
export const db = getFirestore(app);

// Initialiser Analytics (avec vérification pour éviter les erreurs)
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.log('Analytics non disponible:', error);
}
export { analytics };

export default app;